import { getToken, returnError } from './helperFunc';
import {
  fetchPackagesAction,
  fetchActivePackagesAction,
  createPackageAction,
  editPackageAction,
  deletePackageAction,
} from './requestEndpoints';

const SET_PACKAGE_LOADING = 'SET_PACKAGE_LOADING';
const CLEAR_PACKAGE_ERROR = 'CLEAR_PACKAGE_ERROR';

const GET_PACKAGES_SUCCESS = 'GET_PACKAGES_SUCCESS';
const GET_PACKAGES_FAIL = 'GET_PACKAGES_FAIL';

const GET_ACTIVE_PACKAGES_SUCCESS = 'GET_ACTIVE_PACKAGES_SUCCESS';
const GET_ACTIVE_PACKAGES_FAIL = 'GET_ACTIVE_PACKAGES_FAIL';

const CREATE_PACKAGE_SUCCESS = 'CREATE_PACKAGE_SUCCESS';
const CREATE_PACKAGE_FAIL = 'CREATE_PACKAGE_FAIL';

const UPDATE_PACKAGE_SUCCESS = 'UPDATE_PACKAGE_SUCCESS';
const UPDATE_PACKAGE_FAIL = 'UPDATE_PACKAGE_FAIL';

const DELETE_PACKAGE_SUCCESS = 'DELETE_PACKAGE_SUCCESS';
const DELETE_PACKAGE_FAIL = 'DELETE_PACKAGE_FAIL';

export const getPackages = () => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_PACKAGE_ERROR });
    dispatch({ type: SET_PACKAGE_LOADING });

    const { adminReducer } = getState();
    const token = adminReducer ? adminReducer.token : '';

    const { data } = await fetchPackagesAction(token);
    dispatch({ type: GET_PACKAGES_SUCCESS, payload: data });
    return { ok: true };
  } catch (error) {
    const payload = returnError(error);
    dispatch({ type: GET_PACKAGES_FAIL, payload });
    return { ok: false, error: payload };
  }
};

export const getActivePackages = (channel) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_PACKAGE_ERROR });
    dispatch({ type: SET_PACKAGE_LOADING });

    const { user } = getState();
    const token = getToken(user);

    const { data } = await fetchActivePackagesAction(token, channel);
    dispatch({ type: GET_ACTIVE_PACKAGES_SUCCESS, payload: data });
    return { ok: true };
  } catch (error) {
    const payload = returnError(error);
    dispatch({ type: GET_ACTIVE_PACKAGES_FAIL, payload });
    return { ok: false, error: payload };
  }
};

export const createPackage = (reqBody) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_PACKAGE_ERROR });
    dispatch({ type: SET_PACKAGE_LOADING });

    const { adminReducer } = getState();
    const token = adminReducer ? adminReducer.token : '';

    const { data } = await createPackageAction(reqBody, token);
    dispatch({ type: CREATE_PACKAGE_SUCCESS, payload: data });
    return { ok: true };
  } catch (error) {
    const payload = returnError(error);
    dispatch({ type: CREATE_PACKAGE_FAIL, payload });
    return { ok: false, error: payload };
  }
};

export const updatePackage = (reqBody) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_PACKAGE_ERROR });
    dispatch({ type: SET_PACKAGE_LOADING });

    const { adminReducer } = getState();
    const token = adminReducer ? adminReducer.token : '';

    const { data } = await editPackageAction(reqBody, token);
    dispatch({ type: UPDATE_PACKAGE_SUCCESS, payload: data });
    return { ok: true };
  } catch (error) {
    const payload = returnError(error);
    dispatch({ type: UPDATE_PACKAGE_FAIL, payload });
    return { ok: false, error: payload };
  }
};

export const deletePackage = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: CLEAR_PACKAGE_ERROR });
    dispatch({ type: SET_PACKAGE_LOADING });

    const { adminReducer } = getState();
    const token = adminReducer ? adminReducer.token : '';

    const { data } = await deletePackageAction({ id }, token);
    dispatch({ type: DELETE_PACKAGE_SUCCESS, payload: data });
    return { ok: true };
  } catch (error) {
    const payload = returnError(error);
    dispatch({ type: DELETE_PACKAGE_FAIL, payload });
    return { ok: false, error: payload };
  }
};

const initialState = {
  loading: false,
  packageList: [],
  activePackages: [],
};

export const packageReducer = function (state = initialState, action) {
  switch (action.type) {
    case SET_PACKAGE_LOADING:
      return { ...state, loading: true };

    case CLEAR_PACKAGE_ERROR:
      return { ...state, error: null };

    case GET_PACKAGES_SUCCESS:
      return { ...state, packageList: action.payload.data, loading: false, error: null };

    case GET_ACTIVE_PACKAGES_SUCCESS:
      return { ...state, activePackages: action.payload.data, loading: false, error: null };

    case CREATE_PACKAGE_SUCCESS:
      return { ...state, packageCreated: action.payload.data, loading: false, error: null, success: true };

    case UPDATE_PACKAGE_SUCCESS:
      return { ...state, packageUpdated: action.payload.data, loading: false, error: null, success: true };

    case DELETE_PACKAGE_SUCCESS:
      return { ...state, loading: false, error: null, removed: true };

    case GET_PACKAGES_FAIL:
    case GET_ACTIVE_PACKAGES_FAIL:
    case CREATE_PACKAGE_FAIL:
    case UPDATE_PACKAGE_FAIL:
    case DELETE_PACKAGE_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default packageReducer;